import { top_animation } from './modules/top-animation';

document.addEventListener('DOMContentLoaded', () => {
	top_animation();
});